import { useState } from 'react';

import { useSearchResults } from '../hooks';
import { TabName } from '../types';

import Content from './Content/Content';
import Header from './Header/Header';
import * as S from './layout';

const SearchResults = () => {
  const [currentTab, setCurrentTab] = useState<TabName>('products');
  const results = useSearchResults(currentTab);

  return (
    <S.Container>
      <Header results={results} currentTab={currentTab} setCurrentTab={setCurrentTab} />
      <Content results={results} currentTab={currentTab} setCurrentTab={setCurrentTab} />
    </S.Container>
  );
};

export default SearchResults;
